import { render, staticRenderFns } from "./modifyPassword.vue?vue&type=template&id=b6223cb8&scoped=true&"
import script from "./modifyPassword.vue?vue&type=script&lang=js&"
export * from "./modifyPassword.vue?vue&type=script&lang=js&"
import style0 from "./modifyPassword.vue?vue&type=style&index=0&id=b6223cb8&lang=stylus&scoped=true&"
import style1 from "./modifyPassword.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6223cb8",
  null
  
)

export default component.exports